import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
export const FLOW_REVISION_FIELDNAME = 'automation_ui_log_events_flowRevision';
export const GET_FLOW_REVISION_BY_TIMESTAMP = registerQuery({
  fieldName: FLOW_REVISION_FIELDNAME,
  args: ['flowId', 'timestamp'],
  fetcher({
    flowId,
    timestamp
  }) {
    return http.get(`automationplatform/v1/hybrid/revisions/${flowId}/timestamp/${timestamp}`);
  }
});